import { Injectable } from '@angular/core';

import { LogLevels } from './log-level';
import { LoggerMetadata } from './metadata/metadata';

@Injectable({
  providedIn: 'root'
})
export class WriterService {
  public writeMessage(metadata: LoggerMetadata): void {
    const metaString = `${metadata.timestamp} ${metadata.level} [${metadata.fileName}:${metadata.lineNumber}:${metadata.columnNumber}]`;
    const additional = metadata.additional || [];

    switch (metadata.level) {
      case LogLevels.WARN:
        console.warn(`%c${metaString}`, metadata.message, ...additional);
        break;
      case LogLevels.ERROR:
        console.error(`%c${metaString}`, metadata.message, ...additional);
        break;
      case LogLevels.INFO:
        console.info(`%c${metaString}`, metadata.message, ...additional);
        break;
      case LogLevels.DEBUG:
        console.debug(`%c${metaString}`, metadata.message, ...additional);
        break;
      default:
        console.log(`%c${metaString}`, metadata.message, ...additional);
    }
  }
}
